import { Component, OnInit, signal } from '@angular/core';
import { DocType, IdUploadService, NamesForDocType, SidesForDocType, SupportedDocTypes, UploadMethod } from './id-upload.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { BrowserSupportService } from '../browser-support/browser-support.service';
import { ApiAboutService } from '../Services/api-about.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-id-upload',
    templateUrl: './id-upload.component.html',
    styleUrls: ['./id-upload.component.scss'],
    standalone: false
})
export class IdUploadComponent implements OnInit {
  routeName = "";
  cleanDragAndDrop = signal(false); 
  docTypeForm: FormGroup = new FormGroup({
    selectedDocType: this.fb.control("null")
  });
  readonly SidesForDocType = SidesForDocType;

  constructor(
    readonly idUploadService: IdUploadService,
    private readonly router: Router,
    readonly browserSupportService: BrowserSupportService,
    private readonly about: ApiAboutService,
    private readonly fb: FormBuilder
  ) {
    this.routeName = this.router.url;
    this.docTypeOptions = (this.about.aboutInformation.getValue().org_feature_set.scanSettings?.barcodeTypeToScan.types.filter(item => (SupportedDocTypes as string[]).includes(item)) as DocType[]) ?? [];
    this.docTypeOptions.forEach((doc) => {
      this.docTypeForm.addControl(doc, this.fb.control(null))
    })
  }

  readonly isOpen = new BehaviorSubject(false);
  readonly isOpenCamera = new BehaviorSubject(false);
  docTypeOptions: DocType[];
  uploadMethod: UploadMethod = "UNSELECTED";
  selectedFileNew: File | null = null;
  imagePreview: string | null = null; 

  ngOnInit() {
    this.docTypeForm.get('selectedDocType')?.valueChanges.subscribe((value) => {
      this.idUploadService.selectedDocType.set(value);
      if(SupportedDocTypes.includes(value)) {
        this.idUploadService.selectedDocTypeString.set(NamesForDocType.get(value) ?? $localize`ID Card`);
      }
    });
  }

  setMethod(method: UploadMethod) {
    this.idUploadService.idSide.next('FRONT');
    this.uploadMethod = method;
  }

  public get triggerObservable(): Observable<void> {
    return this.idUploadService.uploadState.trigger.asObservable();
  }

  onSelect(event: any): void {
    if (event.rejectedFiles[0] && 'reason' in event.rejectedFiles[0]) {
      this.idUploadService.selectedFile.next(event.rejectedFiles[0]);
      this.idUploadService.uploadState.valid_id = false;
      this.idUploadService.uploadState.id_error = event.rejectedFiles[0].reason;
      this.idUploadService.uploadState.is_selected = true;
    } else {
      this.idUploadService.selectedFile.next(event.addedFiles[0]);
      this.idUploadService.uploadState.valid_id = true;
      this.idUploadService.uploadState.id_error = '';
      this.idUploadService.uploadState.is_selected = true;
    }
  }

  continue(event: any) {
    if(this.uploadMethod === 'FILE'){
      this.isOpen.next(true);
    } else {
      this.isOpenCamera.next(true);
    }
    event.preventDefault();
  }

  back() {
    this.uploadMethod = 'UNSELECTED';
  }

  pickerOptions(): string[] {
    return this.docTypeOptions.map((doc) => NamesForDocType.get(doc) ?? "");
  }

  handleFileUploaded(file: File | null): void {
    if (!file) {
      this.idUploadService.selectedFile.next(new File([''], '')); 
      this.idUploadService.uploadState.valid_id =false;
      this.idUploadService.uploadState.id_error = '';
      this.idUploadService.uploadState.is_selected = false;
      return;
    }
  

    this.selectedFileNew = file;
    this.idUploadService.selectedFile.next(file);
    this.idUploadService.uploadState.valid_id = true;
    this.idUploadService.uploadState.id_error = '';
    this.idUploadService.uploadState.is_selected = true;
    this.cleanDragAndDrop.set(true); 
    setTimeout(() => this.cleanDragAndDrop.set(false), 0); 
    this.isOpen.next(true);
  }
  
}
